// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_DESCRIPTION_STROLLERS_CHARTS = "Rebr\u00ed\u010dky ko\u010d\u00edkov pod\u013ea hodnotenia a ob\u013e\u00fabenosti";
export const SEO_TITLE_STROLLERS_CHARTS = "Rebr\u00ed\u010dky ko\u010d\u00edkov";
export const STROLLERS_CHARTS_TITLE = "Rebr\u00ed\u010dky ko\u010d\u00edkov";
